import * as React from "react";
import { Checkbox, Input, Label } from "uxp/components";
import { IUIPropertyDefinition } from '../common';

export function BooleanProperty(title: string, props: boolean = false, showCategoryTitle = false): IUIPropertyDefinition<boolean> {
    return {
        defaults: props,
        render: (props) => {

            return <div className='wd-prop-item'>
                {!!showCategoryTitle && <div className='wd-prop-item-title'>{title}</div>}
                <div className='wd-prop-item-editor'>
                    <Label>{title}</Label>
                    <Checkbox isValid={true} checked={props.uiProps} onChange={(c) => {
                        props.onChange(c);
                    }} type='switch-box' />
                </div>
            </div>;
        }
    };
}